// urlCreator allow to save search params when use push from history
export const urlCreator = (pathname: string): string => {
  return `${pathname}${window.location.search}`
}
